(function () {
  'use strict';

  function findPurchaseRoot(scope) {
    var root = scope && scope.closest ? scope.closest('[data-product-purchase]') : null;
    if (root) return root;
    return document.querySelector('[data-product-purchase]');
  }

  function findPurchasePanel(scope) {
    var purchase = findPurchaseRoot(scope);
    return purchase ? purchase.querySelector('.product-purchase') : null;
  }

  function initPurchase(scope) {
    var purchase = findPurchaseRoot(scope);
    if (!purchase) return;

    var panel = purchase.querySelector('.product-purchase');
    var buyButton = purchase.querySelector('.compact-btn-buy-now');
    var addButton = purchase.querySelector('.compact-btn--add');
    var form = purchase.querySelector('form[data-type="add-to-cart-form"]');
    var sectionId = purchase.dataset.sectionId || '';

    function updateCompactFormVariant() {
      var variantInput = form ? form.querySelector('input[name="id"]') : null;
      var mainProductInfo = document.querySelector('product-info');
      var mainVariantInput = mainProductInfo
        ? mainProductInfo.querySelector('input[name="id"]')
        : null;

      if (variantInput && mainVariantInput && mainVariantInput.value) {
        variantInput.value = mainVariantInput.value;
        if (buyButton) {
          buyButton.setAttribute('data-variant-id', mainVariantInput.value);
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        window.setTimeout(updateCompactFormVariant, 500);
      });
    } else {
      window.setTimeout(updateCompactFormVariant, 500);
    }

    var mainProductInfo = document.querySelector('product-info');
    if (mainProductInfo) {
      mainProductInfo.addEventListener('change', function (e) {
        if (e.target.name === 'id' || (e.target.name && e.target.name.indexOf('options') === 0)) {
          window.setTimeout(updateCompactFormVariant, 100);
        }
      });
    }

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.source === 'product-packs') return;
      window.setTimeout(updateCompactFormVariant, 50);
    });

    if (buyButton) {
      var buyButtonLabel = buyButton.getAttribute('data-buy-label') || buyButton.textContent;

      function resetBuyButtonState() {
        buyButton.disabled = false;
        buyButton.textContent = buyButtonLabel;
      }

      window.addEventListener('pageshow', resetBuyButtonState);

      buyButton.addEventListener('click', function (e) {
        e.preventDefault();

        var variantId = null;
        if (form) {
          var hiddenInput = form.querySelector('input[name="id"]');
          if (hiddenInput) variantId = hiddenInput.value;
        }
        if (!variantId) variantId = buyButton.getAttribute('data-variant-id');
        if (!variantId) {
          alert('Error: Por favor selecciona una variante del producto');
          return;
        }

        var hasPackSelected = purchase.classList.contains('product-purchase--has-packs');
        var quantity = 1;
        if (!hasPackSelected) {
          var quantityInput = purchase.querySelector('.compact-quantity-input-' + sectionId);
          quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
        }
        if (quantity < 1) quantity = 1;

        buyButton.disabled = true;
        buyButton.textContent = 'Redirigiendo...';

        var checkoutForm = document.createElement('form');
        checkoutForm.method = 'POST';
        checkoutForm.action = '/cart/add';
        checkoutForm.style.display = 'none';

        var idField = document.createElement('input');
        idField.type = 'hidden';
        idField.name = 'id';
        idField.value = variantId;
        checkoutForm.appendChild(idField);

        var qtyField = document.createElement('input');
        qtyField.type = 'hidden';
        qtyField.name = 'quantity';
        qtyField.value = String(quantity);
        checkoutForm.appendChild(qtyField);

        var returnField = document.createElement('input');
        returnField.type = 'hidden';
        returnField.name = 'return_to';
        returnField.value = '/checkout';
        checkoutForm.appendChild(returnField);

        document.body.appendChild(checkoutForm);
        checkoutForm.submit();
      });
    }

    if (addButton && form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var formData = new FormData(form);
        var variantId = formData.get('id');
        var quantity = formData.get('quantity') || 1;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: parseInt(quantity, 10),
          }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function () {
            if (window.theme && window.theme.pubsub) {
              window.theme.pubsub.publish('cart:refresh');
            }
            var originalText = addButton.textContent;
            addButton.textContent = '✓ Added';
            window.setTimeout(function () {
              addButton.textContent = originalText;
            }, 2000);
          })
          .catch(function (error) {
            console.error('Error:', error);
            alert('Error adding product to cart');
          });
      });
    }
  }

  function initAll(scope) {
    var target = scope && scope.querySelector ? scope : document;
    if (target.querySelector && target.querySelector('[data-product-purchase]')) {
      initPurchase(target);
      return;
    }
    if (target.classList && target.classList.contains('section-product-purchase')) {
      initPurchase(target);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
